export default __webpack_public_path__ + "media/images/Masto-G2-Hamac-9cc8305ecaad44c7a888837b79fb4fdf.png";